<template>
    <!-- 兑换活动管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'changeCodeIndex')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="兑换奖品类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['prizeType']">
                            <a-select-option value="1">线上票</a-select-option>
                            <a-select-option value="2">线下票</a-select-option>
                            <a-select-option value="3">优惠券</a-select-option>
                            <a-select-option value="4">储值券</a-select-option>
                            <a-select-option value="5">新优惠券</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="奖品名称">
                        <a-input placeholder="请输入" v-decorator="['prizeName']"></a-input>
                    </a-form-item>
                    <a-form-item label="兑换码有效期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY－MM－DD"
                            v-decorator="['validity']"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <a-button v-if="getBtnByAuth('addCode')" class="mb16" type="primary" @click="toAddCode()">兑换码生成</a-button>
                <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="record => record.id"
                >
                <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                <span slot="prizeType" slot-scope="prizeType">{{['','线上票','线下票','优惠券','储值卡','新优惠券'][prizeType]}}</span>
                <span slot="prizeName" slot-scope="prizeName">{{Boolean(prizeName) ? prizeName : "-"}}</span>
                <span slot="validityStart" slot-scope="a,row">{{row.validityStart ? (row.validityStart + '~' + row.validityEnd) : '不限期'}}</span>
                <span slot="action" slot-scope="a,row">
                    <a v-if="getBtnByAuth('detailCode')" class="text-primary" @click="toDetail(row.id)">查看兑换码详情<a-divider type="vertical"/></a>
                    
                    <a v-if="getBtnByAuth('download')" class="text-primary" @click="downloadZip(row.id)">兑换码下载</a>
                </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: "sitePages",
        components: {},
        props: {},
        data() {
            const columns = [
            {
                title: "序号",
                key: "index",
                scopedSlots: { customRender: "index" }
            },
            {
                title: "兑换奖品类型",
                dataIndex: "prizeType",
                scopedSlots: { customRender: "prizeType" }
            },
            {
                title: "奖品名称",
                dataIndex: "showName"
            },
            {
                title: "内部标识",
                dataIndex: "prizeName",
                scopedSlots: { customRender: "prizeName" }
            },
            {
                title: "本次兑换数量",
                dataIndex: "prizeNum"
            },
            {
                title: "兑换码有效期",
                dataIndex: "validityStart",
                scopedSlots: { customRender: "validityStart" }
            },
            {
                title: "所属活动",
                dataIndex: "activityName"
            },
            {
                title: "兑换码生成时间",
                dataIndex: "createTime"
            },
            {
                title: "兑换操作人",
                dataIndex: "operator"
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }
            ];
            return {
                cityList: [],
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                }
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.shopId = this.shopId
                    const validity = values['validity'] ? values['validity'] : []
                    values.validityEndBegin = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : ''
                    values.validityEnd = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : ''
                    delete values.validity
                    this.$api.changeCode
                    .generateList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                    });
                });
            },
            downloadZip(id) {
                this.$message.success('下载中，请稍后...')
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.$api.changeCode
                    .downloadZip({
                        body: {
                            prizeRedemptionId: id
                        }
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/zip"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.zip'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.loading = false

                    });
                });
            },

            // 跳转至新增页
            toAddCode() {
                this.$router.push({
                    name: "addCode",
                });
            },

            // 跳转至编辑
            toUpdateStore(id) {
                this.$router.push({
                    name: "updateBranchStore",
                    query: { id: id}
                });
            },

            // 跳转至详情
            toDetail(id) {
                this.$router.push({
                    name: "detailCode",
                    query: { id: id}
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList()
        },
        watch: {
            $route(val) {
                val.name == "changeCodeIndex" && this.getList();
            },
            'shopId'() {
                this.getList()
            }
        }
    };
</script>
<style lang="scss">
</style>